<template>
  <v-card class="ma-2 card-container">
    <v-card-title class="text-xs-center display-2 justify-center card-title">
      <v-progress-circular
        v-if="count === null"
        indeterminate
        color="primary"
      ></v-progress-circular>
      <span v-else>{{ count }}</span>
    </v-card-title>

    <v-card-text class="text-xs-center description">
      <slot />
    </v-card-text>

    <v-card-actions class="text-xs-center justify-center card-actions">
      <v-btn
        class="view-btn text-none"
        flat
        @click="$emit('view-all')"
        color="primary"
        >View All</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'SummaryCard',
  props: {
    count: {
      type: Number,
    },
  },
};
</script>

<style scoped>
.card-title {
  height: 70px;
}

.description {
  padding-top: 0;
}

.card-actions {
  border-top: 1px solid #bbb;
}

.view-btn {
  font-weight: 700;
}
</style>
